import React from "react"
import Button from "@kit/design/button"
import { useNavigationContext } from "@kit/design/navigation"
import { trackNavClick } from "./utils/track-nav-click"

const TEXT = "Upgrade plan"

// Free plans (creator-free and newsletter-free, since `newsletter_free` implies
// `free`) get the footer upgrade CTA. Hidden while the sidebar is collapsed.
export function FooterUpgradeButton({ user }) {
  const { collapsed, mobile } = useNavigationContext()

  function handleClick() {
    // Mirrors the old nav's free-plan-upgrade-button event so the two surfaces
    // stay comparable in analytics; only the location differs.
    trackNavClick({
      name: "free_header_upgrade_button",
      text: TEXT,
      elementType: "button",
      location: "vertical_nav",
      isMobile: mobile
    })

    window.location.href = "/upgrade"
  }

  if (collapsed || !user.access_level?.free || user.onTrial) {
    return null
  }

  return (
    <Button is="primary-blue" className="w-full" onClick={handleClick}>
      {TEXT}
    </Button>
  )
}
